import React from 'react'
import PropTypes from 'prop-types'
import './cardStyles.scss'
import { RenderOrgCard } from './renderOrgCard'
import { RenderFloatingOrdCard } from './renderFloatingOrdCard'
import { RenderEmpCard } from './renderEmpCard'
import { RenderEmpDetailsCard } from './renderEmpDetailsCard'

const Card = props => {
	return (
		<>
			{(() => {
				switch (props.cardType) {
					case 'orgCard':
						return RenderOrgCard(props)
					case 'floatingOrgCard':
						return RenderFloatingOrdCard(props)
					case 'empIdCard':
						return RenderEmpCard(props)
					case 'empDetailsCard':
						return RenderEmpDetailsCard(props)
					default:
						return null
				}
			})()}
		</>
	)
}

Card.propTypes = {
	cardType: PropTypes.oneOf([
		'orgCard',
		'floatingOrgCard',
		'empIdCard',
		'empDetailsCard',
	]).isRequired,
}

export { Card }
